import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { colorModeAction } from "../redux/slices/colorModeSlice";

const UseColorMode = () => {
  const dispatch = useAppDispatch();
  const { mode: colorMode } = useAppSelector((state) => state.colorMode);
  const toggleColorMode = () => {
    dispatch(colorModeAction.toggleColorMode());
  };
  const setColorMode = () => {
    dispatch(colorModeAction.toggleColorMode());
  };
  return {
    colorMode,
    toggleColorMode,
    setColorMode,
  };
};

export default UseColorMode;
